import React, { useState, useEffect } from 'react';
import styles from './styles.scss';
import { ICoursesData } from '@services/my-home';
import moment from 'moment';
import AcIcon from 'ac-components/ac-icon';
import { OperationalModal, DisplayModal } from 'ac-components/modal';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { EN_DOWNLOAD } from 'constants/url';
import { useTranslation } from 'hooks/use-translation';

const EnterImg = 'https://web-data.zmlearn.com/image/3m1m3kv8DAGGG6HUqWxU2b/enter.gif';
const NODE_ENV = process.env.NODE_ENV;

/**
 * 课程组件卡片
 */

export default function CourseCard(props: ICoursesData) {
	const { transData } = useTranslation('perfilAndAjustes');

	const [startText, setStartText] = useState('');
	const local = useSelector((state: ConnectState) => state.app.local);

	let modalClose: { (): any; (params?: any): void } | null = null;
	let modalClose2: () => void;

	const getText = (val: number, str: string) => {
		return val ? val + str + ' ' : '';
	};

	useEffect(() => {
		if (props.state === 0) {
			const timeVal = Number(props.lessonStartTime) - new Date().getTime();
			const d = Math.floor(timeVal / (1000 * 60 * 60 * 24));
			const h = Math.floor((timeVal / (1000 * 60 * 60)) % 24);
			const m = Math.floor((timeVal / (1000 * 60)) % 60);
			const text = `${transData.startIn} ${getText(d, 'd')}${getText(h, 'h')}${getText(m, 'm')}`;
			setStartText(text);
		}
	}, [props.lessonStartTime, props.state]);

	/* 点击下载 */
	const down = () => {
		modalClose && modalClose();
		const url = NODE_ENV === 'development' ? 'https://test.air-class.com/' : 'https://air-class.com/';
		const path = local + '/download';
		window.open(`${url}${path}`, '_blank');
	};

	/* 点击卡片 */
	const onCard = (data: ICoursesData, e: any) => {
		e.stopPropagation();
		e.preventDefault();
		/* Zoom课程 */
		if (data.classMode === 1) {
			// 课前20分钟
			if (props.state === 0) {
				modalClose2 = DisplayModal.show({
					title: transData.notice,
					onOk() {
						modalClose2();
					},
					content: transData.zoomNoticeTip,
				});
			}
			// 可进入课程
			if ([1, 2].includes(props.state)) {
				window.open(data.zoomInfo?.zoomLink, '_blank');
			}
		}

		/* Airclass课程 */
		if (data.classMode === 2) {
			// 课前20分钟
			if (props.state === 0) {
				modalClose2 = DisplayModal.show({
					title: transData.notice,
					onOk() {
						modalClose2();
					},
					content: transData.airClassNoticeTip,
				});
			}
			// 可进入课程
			if ([1, 2].includes(props.state)) {
				modalClose = OperationalModal.show({
					title: transData.notice,
					content: transData.noticeTip2,
					size: 'mini',
					okText: transData.download,
					cancelText: transData.ok,
					onCancel: () => modalClose && modalClose(),
					async onOk() {
						down();
					},
				});
			}
		}

		// 已完成课程
		if ([3, 4].includes(data?.state)) {
			modalClose = OperationalModal.show({
				title: transData.notice,
				content: transData.noticeTip,
				size: 'mini',
				okText: transData.download,
				cancelText: transData.ok,
				onCancel: () => modalClose && modalClose(),
				async onOk() {
					down();
				},
			});
		}
	};

	return (
		<div
			className={styles.card_warp}
			onClick={(e) => {
				onCard(props, e);
			}}>
			{props.classMode === 1 && (
				<span className={styles.zoom_tip}>
					<i></i>
					Zoom
				</span>
			)}
			<div className={styles.c_title_warp}>
				<span className={styles.sign}>{transData.lessonType.find((item: any, i: number) => i === props.lessonType)}</span>
				<h3 className={styles.c_title}>
					{props.lessonSubjectName && props.lessonName
						? `${props.lessonSubjectName}:${props.lessonName}`
						: props.lessonName || props.lessonSubjectName}
				</h3>
			</div>
			<div className={styles.info_warp}>
				<AcIcon icon={'icon_card_time'} color={'#626573'} size={16} />
				<span>
					{moment(props.lessonStartTime).format('YYYY/MM/DD HH:mm')} -{' '}
					{moment(props.lessonEndTime).format('YYYY/MM/DD HH:mm')?.substring(11, 16)}
				</span>
				<span>({Intl.DateTimeFormat().resolvedOptions().timeZone})</span>
			</div>
			<div className={styles.info_warp}>
				<AcIcon icon={'icon_card_teacher'} color={'#626573'} size={16} />
				<span>{props.teacher?.name}</span>
			</div>
			{[0, 1, 2].includes(props.state) && (
				<div className={styles.info_tip}>
					{/* 课程开始时间 */}
					{props.state === 0 && <span className={styles.start_tip}>{startText}</span>}

					{/* 可以进入课程 */}
					{[1, 2].includes(props.state) && (
						<p className={styles.enter_wrap}>
							<img className={styles.enter_img} src={EnterImg} alt="" />
							<span
								className={styles.enter_btn}
								onClick={(e) => {
									onCard(props, e);
								}}>
								{transData.enter}
							</span>
						</p>
					)}
				</div>
			)}
		</div>
	);
}
